import { ReactNode } from 'react';

type ExpenseItemProps = {
  title: ReactNode;
  sum: string;
  bold?: boolean;
  disableMargin?: boolean;
  onClick?: () => void;
};

export const ExpenseItem = ({
  title,
  sum,
  bold,
  disableMargin,
  onClick,
}: ExpenseItemProps) => {
  return (
    <div
      onClick={onClick}
      className={`flex justify-between text-sm ${bold && 'font-semibold'} ${
        !disableMargin && 'mb-2'
      }`}
    >
      <label>{title}</label>
      <span className="ml-2 shrink-0">{sum}</span>
    </div>
  );
};
